// D35 v17 G-M9b (lab talk.css:2546-2557, shell.js:336-379): barra de rolagem própria (4 px, --accent, aparece no hover da coluna ou
// enquanto rola) na lista da fila e na coluna de contexto da tela de tickets nova. A nativa some pelo CSS (G-M9c).
// - Fila: 1× no init; o #tk-fila-itens cresce ("Carregar mais", sync) sem a lista mudar de tamanho → observado à parte.
// - Contexto: a .tk-ctx-in nasce a cada detalhe (replaceContent do .open-ticket-detail). Um MutationObserver childList no
//   .open-ticket-detail (o padrão do ConversaFim) solta a instância antiga e liga a nova; os filhos dela (leitura, linha do tempo) são
//   observados, porque a linha do tempo chega por AJAX e cresce por dentro.
// - A conversa fica de fora (v17 §13 R-6: o ConversaFim conta o último filho da lista como mensagem nova).
const NavScroll = require('./NavScroll');

const RolagemPropria = function () {

    let ctx = null;   // { el, inst }

    const ligarCtx = (detalhe) => {
        const el = detalhe.querySelector('.tk-ctx-in');
        if (ctx && ctx.el === el && el && el.isConnected) return;
        if (ctx) { ctx.inst.soltar(); ctx = null; }
        if (!el) return;
        ctx = { el, inst: NavScroll.ligar(el, { observar: Array.from(el.children) }) };
    };

    return {
        init: function () {
            const detalhe = document.querySelector('.open-ticket-detail');
            if (!detalhe) return;   // só na tela de tickets nova
            const lista = document.getElementById('tk-fila-lista');
            if (lista) NavScroll.ligar(lista, { observar: ['#tk-fila-itens'] });
            ligarCtx(detalhe);
            new MutationObserver(() => ligarCtx(detalhe)).observe(detalhe, { childList: true });
        },
    };
}();

module.exports = RolagemPropria;
